import type { MotifComponent, MotifComponentProps } from '../../motif';
import { m } from '../../motif/m';

export const editorialGalleryCardLightVars: MotifComponentProps<MotifComponent.EDITORIAL_GALLERY_CARD> =
  {
    '--editorial-gallery-card-hover-background-color': m('--neutral-v150'),
  } as const;

export const editorialGalleryCardDarkVars: MotifComponentProps<MotifComponent.EDITORIAL_GALLERY_CARD> =
  {
    '--editorial-gallery-card-hover-background-color': m('--neutral-v625'),
  } as const;
